import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { BrnService } from '../../services/brn.service';
import { GOOGLE_ADS_REDIRECT_URI } from '../../constants';

@Component({
  selector: 'app-google-ads-oauth',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './google-ads-oauth.component.html',
  styleUrls: ['./google-ads-oauth.component.scss']
})
export class GoogleAdsOauthComponent implements OnInit {
  loading = true;
  error = '';
  success = false;

  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private brnService: BrnService
  ) {}

  async ngOnInit() {
    // Get URL parameters
    this.route.queryParams.subscribe(async params => {
      const code = params['code'];
      const state = params['state']; // This contains bot_id_customer_id
      const error = params['error'];

      console.log('Google Ads OAuth - code:', code);
      console.log('Google Ads OAuth - state:', state);
      console.log('Google Ads OAuth - error:', error);

      if (error) {
        this.error = `OAuth error: ${error}`;
        this.loading = false;
        return;
      }
      
      if (code && state) {
        // State parameter now only contains bot_id
        const botId = state;
        console.log('Parsed botId:', botId);
        
        await this.handleOAuthCallback(code, botId);
      } else {
        this.error = 'Missing required OAuth parameters';
        this.loading = false;
      }
    });
  }

  private async handleOAuthCallback(code: string, botId: string) {
    try {
      this.loading = true;
      this.error = '';

      // Create the Google Ads service with the OAuth code
      const redirectUrl = GOOGLE_ADS_REDIRECT_URI;
      
      const response = await firstValueFrom(
        this.brnService.createGoogleAdsService(botId, code, redirectUrl)
      );
      
      if (response.status) {
        this.success = true;
        console.log('Google Ads service created successfully:', response.service);
        // Redirect back to the store page after a short delay
        setTimeout(() => {
          this.router.navigate(['/store', botId]);
        }, 2000);
      } else {
        this.error = 'Failed to create Google Ads service';
      }
    } catch (error: any) {
      console.error('Google Ads OAuth callback error:', error);
      this.error = error.error?.error || 'Failed to complete Google Ads connection';
    } finally {
      this.loading = false;
    }
  }
} 